import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { tap } from 'rxjs/operators';
import { ApiService } from '@app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private _apiService: ApiService) {}

  downloadFile(data: any, fileName: string) {
    const blob = new Blob([data], { type: 'text/csv' });
    saveAs(blob, fileName);
  }

  getSlaAccountabilityReportData(
    shopId: number,
    range: {
      startDateValue: number;
      endDateValue: number;
    },
  ) {
    const { startDateValue, endDateValue } = range;

    return this._apiService
      .get(`analytics/admin-dashboard/late-sla-orders/${shopId}`, {
        params: {
          start: `${startDateValue}`,
          end: `${endDateValue}`,
        },
        responseType: 'text',
        headers: {
          'Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      })
      .pipe(tap((data: any) => this.downloadFile(data, 'sla-report.csv')));
  }

  getDeliveryPromiseAccountabilityReportData(
    shopId: number,
    range: {
      startDateValue: number;
      endDateValue: number;
    },
  ) {
    const { startDateValue, endDateValue } = range;

    return this._apiService
      .get(`analytics/admin-dashboard/late-promise-orders/${shopId}`, {
        params: {
          start: `${startDateValue}`,
          end: `${endDateValue}`,
        },
        responseType: 'text',
        headers: {
          'Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      })
      .pipe(tap((data: any) => this.downloadFile(data, 'delivery-promise-report.csv')));
  }
}
